import { lazy } from "react";

// project imports
import Loadable from "../component/Loadable/Index";
import MainLayouts from "../layout/MainLayout/index";

// login option 3 routing
const HomePage = Loadable(
  lazy(() => import("../container/HomePage/Index"))
);

const Dashboard = Loadable(
  lazy(() => import("../container/Dashboard/Index"))
)

const ContractManagement = Loadable(
  lazy(() => import('../container/ContractManagement/Index'))
)

const NewProject = Loadable(
  lazy(() => import('../container/ContractManagement/NewProject'))
)

const ContractManagementView = Loadable(
  lazy(() => import('../container/ContractManagement/ContractManagement'))
)

const ViewContract = Loadable(
  lazy(() => import('../container/ContractManagement/ViewContract/Index'))
)

const Users = Loadable(lazy(() => import("../container/User/Index")));

// ==============================|| MAIN ROUTING ||============================== //

const MainLayout = {
  path: "/",
  element: <MainLayouts />,
  children: [
    {
      path: "/home-page",
      element: <HomePage />,
    },
    {
      path:"/dashboard",
      element:<Dashboard/>
    },
    {
      path:"/contract-management",
      element:<ContractManagement/>
    },
    {
      path:"/new-project",
      element:<NewProject/>
    },
    {
      path:"/contract-management-view",
      element:<ContractManagementView/>
    },
    {
      path:"/view-contract/:guid/:path",
      element:<ViewContract />
    },
    {
      path: "/users-list",
      element: <Users />,
    },
  ],
};

export default MainLayout;
